import { Navigate } from "react-router-dom";

/**
 * ── Protected Route ──────────────────────────────────────────────────────────
 * Wraps routes that require authentication.
 *
 * Props:
 *   user              — the logged-in user object (or null)
 *   adminOnly         — if true, only admins can access
 *   interviewerAllowed— if true, admins AND interviewers can access
 *   userOnly          — if true, only regular users can access
 *                       (admins → /admin-panel, interviewers → /interviewer-panel)
 */
export default function ProtectedRoute({
  user,
  children,
  adminOnly = false,
  interviewerAllowed = false,
  userOnly = false,
}) {
  // Not logged in → go home
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Admin-only route — non-admins get bounced to their dashboard
  if (adminOnly && user.role !== "admin") {
    if (user.role === "interviewer")
      return <Navigate to="/interviewer-panel" replace />;
    return <Navigate to="/dashboard" replace />;
  }

  // Interviewer-allowed route — regular users get bounced to their dashboard
  if (
    interviewerAllowed &&
    user.role !== "admin" &&
    user.role !== "interviewer"
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  // User-only route — admins and interviewers get bounced to their own dashboards
  if (userOnly && user.role !== "user") {
    if (user.role === "admin") return <Navigate to="/admin-panel" replace />;
    if (user.role === "interviewer")
      return <Navigate to="/interviewer-panel" replace />;
  }

  return children;
}
